












import { Vue, Component, Prop } from "vue-property-decorator";
import { mapActions } from 'vuex';
import IFilter, {IFilterOption} from "../../models/filter-model";

@Component({
  methods: {
    ...mapActions(['setSelectedFilter']) 
  }
})
export default class FilterOptionComponent extends Vue {
  @Prop() filterOption!: IFilterOption;
  @Prop() filter!: IFilter;
  @Prop() public compactView!: boolean;
}
